(() => {
  function initFeatureMediaStory(section) {
    if (!section || section.dataset.fmsReady === 'true') return;

    const tabs = Array.from(section.querySelectorAll('[data-fms-tab]'));
    const panels = Array.from(section.querySelectorAll('[data-fms-panel]'));
    if (!tabs.length || !panels.length) {
      section.dataset.fmsReady = 'true';
      return;
    }

    const activate = (index) => {
      tabs.forEach((tab, i) => {
        const isActive = i === index;
        tab.classList.toggle('is-active', isActive);
        tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
      });

      panels.forEach((panel, i) => {
        panel.classList.toggle('is-active', i === index);
      });
    };

    tabs.forEach((tab, index) => {
      tab.addEventListener('click', () => activate(index));
    });

    activate(0);
    section.dataset.fmsReady = 'true';
  }

  function initAll(root = document) {
    root.querySelectorAll('[data-fms-section]').forEach(initFeatureMediaStory);
  }

  document.addEventListener('DOMContentLoaded', () => initAll());
  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
})();
